export default 'M12 4.12V20.5H3.81zm10.78 15.97L13.79 2.11A2 2 0 0 0 12 1c-.71 0-1.42.37-1.8 1.1l-8.98 18A2 2 0 0 0 3.01 23H21a2 2 0 0 0 1.78-2.9';